export enum SubscriptionRequestFormKeys {
  LAST_NAME = 'lastName',
  FIRST_NAME = 'firstName',
  EMAIL = 'email',
  PHONE_NUMBER = 'phoneNumber',
  COMPANY_NAME = 'companyName',
  SIRET = 'siret',
  COMPANY_JOB = 'companyJob',
  VISITED_SITE = 'visitedSite',
}
